const styles = {
  container: {
    position: "relative",
  },
  disabled: {
    backgroundColor: "rgba(239, 239, 239, 0.3)",
  },
  datePicker: {
    position: "absolute",
    top: 53,
    left: 0,
    zIndex: 200,
    background: "#FFFFFF",
    boxShadow:
      "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
  },
  calendar: {
    width: "20.667em",
  },
  input: {
    borderBottom: "1px solid rgba(143, 146, 161, 0.3)",
    // paddingBottom: 3,
  },
  inputLabel: {
    fontWeight: 500,
    fontSize: 14,
    color: "#8F92A1",
    // marginBottom: 5,
  },
  inputValue: {
    fontWeight: 500,
    fontSize: 16,
    color: "rgba(23, 23, 23, 0.25)",
  },
  selected: {
    color: "#171717",
  },
  inputValContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  placeholder: {
    position: "fixed",
    left: 0,
    top: 0,
    zIndex: 199,
    width: "100%",
    height: "100vh",
    backgrondColor: "transparent",
    opacity: 1,
  },
  // clearButton: {
  //   cursor: "pointer",
  //   marginLeft: "10px",
  //   // additional styles for the clear button
  // },
};
export default styles;
